import { render, staticRenderFns } from "./RetroImage.vue?vue&type=template&id=b22536e0&scoped=true&"
import script from "./RetroImage.vue?vue&type=script&lang=js&"
export * from "./RetroImage.vue?vue&type=script&lang=js&"
import style0 from "./RetroImage.vue?vue&type=style&index=0&id=b22536e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22536e0",
  null
  
)

export default component.exports